import Tooltip from './Tooltip'
import { events } from './bus'

const addHoverEventListener = (el, value) => {
  const mouseover = (srcEvent) => {
    events.$emit('show:hover', { value, el, srcEvent })
  }

  const mouseleave = (srcEvent) => {
    events.$emit('hide:hover', { value, el, srcEvent })
  }

  el.addEventListener('mouseover', mouseover)
  el.addEventListener('mouseleave', mouseleave)

  el.$popoverRemoveHoverHandlers = () => {
    events.$emit('hide:hover')
    el.removeEventListener('mouseover', mouseover)
    el.removeEventListener('mouseleave', mouseleave)
  }
}

export default {

  install(Vue) {
    Vue.component('tooltip', Tooltip)

    Vue.directive('tooltip', {
      bind(el, binding) {
        addHoverEventListener(el, binding.value)
      },

      unbind(el, binding) {
        el.$popoverRemoveHoverHandlers()
      }
    })
  }

}



// WEBPACK FOOTER //
// ./src/plugins/tooltip/index.js